/**
 * @see https://laravel-news.com/building-flexible-axios-clients
 */
import axios from 'axios';
import store from '@/store';
import router from '@/router';
import swal from 'sweetalert2';

const httpClient = (baseURL = null) => {
    const options = {baseURL};

    options.headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
    };

    let token = document.head.querySelector('meta[name="csrf-token"]');

    if (token && token.content.match('/(Development)$/g')) {
        options.headers['X-CSRF-TOKEN'] = token.content;
    }

    const client = axios.create(options);

    client.interceptors.request.use(request => {
        // request.headers['X-Socket-Id'] = Echo.socketId()

        /**
         * 'X-CSRF-TOKEN' berasal dari document.head.querySelector('meta[name="csrf-token"]')
         * problemnya ketika token berubah padahal single page application tidak melakukan perubahan kecuali di refresh
         * maka token akan invalid, untuk amannya cukup gunakan token yang berasal dari cookie, dengan key XSRF-TOKEN
         * sayangnya laravel tidak pernah mengecek XSRF-TOKEN jika CSRF-TOKEN dikirim, maka dari itu kita unset X-CSRF-TOKEN
         * indikasi awal problem ini: login sukses karena token benar, kemudian setiap kali post akan error,
         *                            tetapi setelah di refresh maka akan sukses seterusnya
         */

        // if (request.headers.common['X-CSRF-TOKEN']) {
        //     delete request.headers.common['X-CSRF-TOKEN'];
        // }

        return request;
    });

    client.interceptors.response.use(response => response, error => {
        const {status, data} = error.response;

        let error_message;
        let error_title;
        if (data.message) {
            error_title = data.message;
            error_title = "";
            error_message = (data.errors && data.errors.length) ? data.errors.join(", ") : "";
        } else {
            error_title = "";
            error_message = data.results && data.results.message;
        }

        swal.fire({
            type: 'error',
            title: error_title,
            text: error_message + "!",
            reverseButtons: false,
            confirmButtonText: 'ok',
        });

        if (status === 400 || status === 401 || status === 403) {
            store.dispatch('auth/clearUserData').then(() => {
                router.push({name: 'login'});
            });
        }

        if(status === 419) {
            window.location.reload();
        }

        return Promise.reject(error);
    });

    return client;
};

export default httpClient;